export class User {
  access_token?: string;
  username: string;
  password?: string;
  status?: string;
}
